import React, {Component} from 'react'
import Popup from "reactjs-popup";
import Grid from "../../../Utils/Grid";
import {TableHeaderColumn} from "react-bootstrap-table";
import {customActions} from "../../../Utils/Grid/CustomActions";
import Card from "Utils/Cards/Card"
import Header from "Utils/Grid/Header";
import { TooltipFormat, formatActivo } from '../../../Utils/renderField/renderReadField';
import ModalFleteExterno from "../FleteExterno/ModalFleteExterno";
import { Link } from "react-router-dom";
const flete_img = require('assets/img/icons/liquidaciones_activo.png');
const bitacora_img = require('assets/img/icons/historico_activo.png');

export default class FincasList extends Component{
    state = {
        fincaFleteExterno: null,
    };

    componentWillMount() {
        const { listar, page } = this.props;
        listar(page);
    }

    abrirFleteExterno = (row) => () => {
        this.setState({ fincaFleteExterno: row });
    };

    cerrarFleteExterno = () => {
        this.setState({ fincaFleteExterno: null });
    };

    fleteExternoGuardado = () => {
        const { listar, page } = this.props;
        this.setState({ fincaFleteExterno: null });
        listar(page);
    };

    // Se agrega el acceso al flete ajeno junto a las acciones ya existentes de la fila
    accionesFormat = (cell, row) => {
        const { desactivar, activar } = this.props;
        return (
            <div className="d-flex justify-content-center align-items-center">
                {customActions({ editar: "finca", ver: "finca", desactivar, activar })(cell, row)}
                <div className="d-flex gap-5" style={{ marginLeft: '-2px'}}>
                    {this.fleteExternoFormat(cell, row)}
                    {this.bitacoraFletesFormat(cell, row)}
                </div>
            </div>
        )
    };

    // Modal para configurar precios de flete ajeno
    fleteExternoFormat = (cell, row) => {
        return (
            <a
                style={{cursor: "pointer"}}
                onClick={this.abrirFleteExterno(row)}
            >
                <img
                    src={flete_img}
                    alt="Flete ajeno"
                    className="action_img"
                    title="Editar precio de flete ajeno"
                />
            </a>
        )
    };
    // Historial de cambios en los precios de flete de la finca
    bitacoraFletesFormat = (cell, row) => {
        return (
            <Link to={`/finca/${row.id}/bitacora_fletes`}>
                <img
                    src={bitacora_img}
                    alt="Bitácora de fletes"
                    className="action_img"
                    style={{width: '20px', height: '20px'}}
                    title="Ver bitácora de fletes"
                />
            </Link>
        )
    };
    contactoFormat = (cell, row) => {
        if (row.de_baja){
            return (
                <Popup
                    trigger={<span className="tachado-touch">{row.nombre_contacto}</span>}
                    position="top right"
                    on="hover"
                >
                    <span className="popup-title">FINCA DADA DE BAJA</span>
                    <span className="popup-text">{row.justificacion_baja}</span>
                </Popup>
            )
        } else {
            return <span>{row.nombre_contacto}</span>
        }
    };

    render() {
        const { listar: onPageChange, onSortChange, eliminar, desactivar, activar } = this.props;
        const { data, loader, page, solo_flete_externo, filtroFleteExternoChange } = this.props;
        return(
            <div className="mb-4 col-12">
                <Card
                    icon="configuraciones_activo"
                    titulo="FINCA"
                    subtitulo="Del sistema">
                    <Header to="finca/crear" textBtn="CREAR FINCA" {...this.props} />
                    <div className="d-flex align-items-center mb-3 justify-content-end">
                        <label className="d-flex align-items-center mb-0 gap-10" style={{cursor: "pointer"}}>
                            <input
                                type="checkbox"
                                className="checkbox"
                                checked={!!solo_flete_externo}
                                onChange={e => filtroFleteExternoChange(e.target.checked)}
                            />
                            <span>Solo fincas con precio de flete ajeno</span>
                        </label>
                    </div>
                    <Grid hover striped data={data} loading={loader} onPageChange={onPageChange}
                          onSortChange={onSortChange} page={page} >
                        <TableHeaderColumn
                            dataField="id"
                            dataAlign="center"
                            width='20%'
                            dataSort
                            dataFormat={this.accionesFormat}
                        />
                        <TableHeaderColumn
                            isKey
                            dataField="nombre"
                            dataSort
                            // dataFormat={(cell, row) =>
                            //     <span className={row.de_baja ? 'tachado' : ''}>{cell}</span>
                            // }
                            dataFormat={TooltipFormat}
                        >
                            FINCA
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="propietario"
                            dataSort
                            dataFormat={TooltipFormat}
                        >
                            PROPIETARIO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="perfil"
                            dataSort
                            dataFormat={TooltipFormat}
                        >
                            PERFIL
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="id"
                            dataSort
                            dataFormat={this.contactoFormat}
                        >
                            CONTACTO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataAlign="center"
                            dataField="id"
                            width='8%'
                            dataSort
                            dataFormat={TooltipFormat}
                        >
                            CÓDIGO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="informacion_completa"
                            dataAlign="center"
                            dataFormat={cell => formatActivo(cell)}
                        >
                            LISTA
                        </TableHeaderColumn>
                    </Grid>
                </Card>
                <ModalFleteExterno
                    finca={this.state.fincaFleteExterno}
                    onClose={this.cerrarFleteExterno}
                    onGuardado={this.fleteExternoGuardado}
                />
            </div>
        )
    }
}
